import { AlarmConfigurationType } from "enums/alarm-configuration-type"

/**
 * Helper function to get AlarmConfigurationType from category string
 */
export const getConfigurationTypeFromCategory = (
  category: 'ANPR' | 'AHCR'
): AlarmConfigurationType => {
  return category === 'ANPR'
    ? AlarmConfigurationType.ANPR
    : AlarmConfigurationType.AHCR
}

/**
 * Helper function to get category string from AlarmConfigurationType
 */
export const getCategoryFromConfigurationType = (
  type: AlarmConfigurationType
): 'ANPR' | 'AHCR' => {
  return type === AlarmConfigurationType.ANPR ? 'ANPR' : 'AHCR'
}

/**
 * Helper function to get friendly display name
 */
export const getConfigurationTypeLabel = (
  type: AlarmConfigurationType
): string => {
  return type === AlarmConfigurationType.ANPR ? 'Veículos' : 'Pessoas'
}
